import { AccountTypes } from 'svr/lib/Payments/Constants'

export const isUnifiedPaymentResponse = provider =>
  [AccountTypes.NETWORK_REDUX_DIRECT_PURCHASE, AccountTypes.SAFERPAY].indexOf(provider) > -1
